﻿import LandingPage from "./LandingPage.svelte";
import ReturningLandingPage from "./ReturningLandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import YourId from "./YourId.svelte";
import TypeOfClaim from "./TypeOfClaim.svelte";
import ClaimForYourself from "./ClaimForYourself.svelte";
import ClaimForYourSpouse from "./ClaimForYourSpouse.svelte";
import ClaimForYourParent from "./ClaimForYourParent.svelte";
import BankAccountDetails from "./BankAccountDetails.svelte";
import AdditionalInformation from "./AdditionalInformation.svelte";
import Confirmation from "./Confirmation.svelte";
import Review from "./Review.svelte";
import ThankYou from "./ThankYou.svelte";
import Error from "../Error.svelte";
import SaveAndCloseThankYou from "./SaveAndCloseThankYou.svelte";
import RegistrationStatus from "./RegistrationStatus.svelte";

const title = "Northern Territory Stolen Wages Class Action";

const registrationPageList = [
	{
		pageIndex: 0,
		component: ReturningLandingPage,
		title: "REGISTRATION FORM",
		showInTracker: false,
		routeId: "/ReturnedRegistration",
		nextPage: "/SettlementRegistration/PersonalDetails",
		properties: {
			pageTitle: `${title}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 0,
		component: RegistrationStatus,
		title: "REGISTRATION FORM",
		showInTracker: false,
		routeId: "/RegistrationStatus",
		nextPage: "/SettlementRegistration/PersonalDetails",
		properties: {
			pageTitle: `${title}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 0,
		component: LandingPage,
		title: "REGISTRATION FORM",
		showInTracker: false,
		routeId: "/SettlementRegistration",
		nextPage: "/SettlementRegistration/PersonalDetails",
		properties: {
			pageTitle: `${title}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 1,
		component: PersonalDetails,
		title: "Personal Details",
		showInTracker: true,
		routeId: "/SettlementRegistration/PersonalDetails",
		nextPage: "/SettlementRegistration/YourID",
		previousPage: (model) =>
			model.settlementRegistrationType == "Returning Registration"
				? "/ReturnedRegistration"
				: "/SettlementRegistration",
		properties: {
			pageTitle: `${title} - Personal Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Personal Details"
		}
	},
	{
		pageIndex: 2,
		component: YourId,
		title: "Your ID",
		showInTracker: true,
		routeId: "/SettlementRegistration/YourID",
		nextPage: "/SettlementRegistration/TypeOfClaim",
		previousPage: "/SettlementRegistration/PersonalDetails",
		properties: {
			pageTitle: `${title} - Your ID`,
			persistUrl: "/api/project",
			lastVisitedPage: "Your ID"
		}
	},
	{
		pageIndex: 3,
		component: TypeOfClaim,
		title: "Type of Claim",
		showInTracker: true,
		routeId: "/SettlementRegistration/TypeOfClaim",
		previousPage: "/SettlementRegistration/YourID",
		nextPage: (model) =>
			model.registrationType == "Individual (Myself)"
				? "/SettlementRegistration/ClaimForYourself"
				: model.registrationType == "Individual (Spouse)"
					? "/SettlementRegistration/ClaimForYourSpouse"
					: "/SettlementRegistration/ClaimForYourParent",
		properties: {
			pageTitle: `${title} - Type Of Claim`,
			persistUrl: "/api/project",
			lastVisitedPage: "Type Of Claim"
		}
	},
	{
		pageIndex: 4,
		component: ClaimForYourself,
		title: "Claim For Yourself",
		showInTracker: (model) => model.registrationType == "Individual (Myself)",
		routeId: "/SettlementRegistration/ClaimForYourself",
		previousPage: "/SettlementRegistration/TypeOfClaim",
		nextPage: "/SettlementRegistration/YourBankAccountDetails",
		properties: {
			pageTitle: `${title} - Claim For Yourself`,
			persistUrl: "/api/project",
			lastVisitedPage: "Claim For Yourself"
		}
	},
	{
		pageIndex: 5,
		component: ClaimForYourSpouse,
		title: "Claim For Your Spouse",
		showInTracker: (model) => model.registrationType == "Individual (Spouse)",
		routeId: "/SettlementRegistration/ClaimForYourSpouse",
		previousPage: "/SettlementRegistration/TypeOfClaim",
		nextPage: "/SettlementRegistration/YourBankAccountDetails",
		properties: {
			pageTitle: `${title} - Claim For Your Spouse`,
			persistUrl: "/api/project",
			lastVisitedPage: "Claim For Your Spouse"
		}
	},
	{
		pageIndex: 6,
		component: ClaimForYourParent,
		title: "Claim For Your Parent",
		showInTracker: (model) => model.registrationType == "Individual (Parent)",
		routeId: "/SettlementRegistration/ClaimForYourParent",
		previousPage: "/SettlementRegistration/TypeOfClaim",
		nextPage: "/SettlementRegistration/YourBankAccountDetails",
		properties: {
			pageTitle: `${title} - Claim For Your Parent`,
			persistUrl: "/api/project",
			lastVisitedPage: "Claim For Your Parent"
		}
	},
	{
		pageIndex: 7,
		component: BankAccountDetails,
		title: "Payment Details",
		showInTracker: true,
		routeId: "/SettlementRegistration/YourBankAccountDetails",
		previousPage: (model) =>
			model.registrationType == "Individual (Myself)"
				? "/SettlementRegistration/ClaimForYourself"
				: model.registrationType == "Individual (Spouse)"
					? "/SettlementRegistration/ClaimForYourSpouse"
					: "/SettlementRegistration/ClaimForYourParent",
		nextPage: "/SettlementRegistration/AdditionalInformation",
		properties: {
			pageTitle: `${title} - Your Bank Account Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Your Bank Account Details"
		}
	},
	{
		pageIndex: 8,
		component: AdditionalInformation,
		title: "Additional and Authorisation Details",
		showInTracker: true,
		routeId: "/SettlementRegistration/AdditionalInformation",
		previousPage: "/SettlementRegistration/YourBankAccountDetails",
		nextPage: "/SettlementRegistration/Confirmation",
		properties: {
			pageTitle: `${title} - Additional and Authorisation Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Additional and Authorisation Details"
		}
	},
	{
		pageIndex: 9,
		component: Confirmation,
		title: "Confirmation",
		showInTracker: true,
		routeId: "/SettlementRegistration/Confirmation",
		previousPage: "/SettlementRegistration/AdditionalInformation",
		nextPage: "/SettlementRegistration/ThankYou",
		properties: {
			pageTitle: `${title} - Confirmation`,
			nextPageLabel: "Submit",
			persistUrl: `/api/registration`,
			lastVisitedPage: "Confirmation"
		}
	},
	{
		pageIndex: 10,
		component: SaveAndCloseThankYou,
		title: "Registration Saved",
		showInTracker: false,
		routeId: "/SettlementRegistration/SaveAndClose",
		properties: {
			pageTitle: `${title} - Thank you`
		}
	},
	{
		pageIndex: 11,
		component: ThankYou,
		title: "Registration Submitted",
		showInTracker: false,
		routeId: "/SettlementRegistration/ThankYou",
		properties: {
			pageTitle: `${title} - Thank you`
		}
	},
	{
		pageIndex: 12,
		component: Review,
		title: "Review",
		showInTracker: false,
		routeId: "/Review",
		properties: {
			pageTitle: `${title} - Review`
		}
	},
	{
		pageIndex: 13,
		component: Error,
		title: "Error",
		showInTracker: false,
		routeId: "*/Error",
		properties: {
			pageTitle: `${title} - Error`
		}
	}
];

export default registrationPageList;
